import React from 'react';
import ReactDOM from 'react-dom';

import '../assets/css/q2cui_oss.css';
import '../assets/css/oswidget.css';

import Shipping_RGB_blue_NT from '../assets/images/Shipping_RGB_blue_NT.png';
import train_icon from '../assets/images/train_icon.png';
import airplane from '../assets/images/airplane.png';
import vessel from '../assets/images/vessel.png';

import '../vendors/q2cui_oss.js';
//import '../vendors/moment.min.js';
var moment = require('moment');
var _ = require('lodash');
var ReactRecaptcha = require('react-recaptcha');

import '../vendors/daterangepicker.js';

import {ModalWithClose, ModalTitle, ModalBody,
        exportExcelMaxLimit, L, 
        SimpleDataGrid} from '../common/components.jsx';

import {SearchResult, OSWidget} from './osWidget.jsx';

import {DateChooser} from '../common/dateChooser.jsx';

//js common
import '../common/plugins.js';

// osWidget_locales.js
//import {I18NFile} from '../common/osWidget_locales_HPI.js'

// GEGA T and I18N defined in wepack config as global available
import {fmDate, fmDateTime, fmNum} from '../common/i18n.js';

/*----------------------------------------------------------------------------
|
|   OSS Widget external implementation
|
|
|   written by Jochen Loewer and Adolf Krauss
|   July 2014
|
\--------------------------------------------------------------------------*/

 jQuery.fn.highlight = function (str, className) {
      var regex = new RegExp(str, "gi");
      return this.each(function () {
          $(this).contents().filter(function() {
              return this.nodeType == 3 && regex.test(this.nodeValue);
          }).replaceWith(function() {
               return (this.nodeValue || "").replace(regex, function(match) {
                  return "<span class=\"" + className + "\">" + match + "</span>";
              });
          });
      });
  };
 function fmAddress ( addressLines  ) {

   if (!addressLines || !(addressLines instanceof Array)) return "";

   return addressLines.map(function(line) {
      return <div className="addressLine">{line}</div>
   });
 }

function fmArray (arr) {

    if (!arr || !(arr instanceof Array)) return "";

    return arr.map(function(line) {
        return <div>{line}</div>
    });
}


//----------------------------------------------------------------------
//  PublicOrderSelectList   --  list for selecting an order
//                        in case multiple orders match filter
//
//----------------------------------------------------------------------
class PublicOrderSelectList extends React.Component {

  handleClick(legacy_order_no,k) {
    //console.log ("Running handleClick for " + legacy_order_no,k);
    ShowOrderWidgetPublic(legacy_order_no,k);
  }

  render() {
    console.log("Response3: " +(JSON.stringify(this.props)));
    var orders  = this.props.orders;
    var kList   = this.props.k;
    var self    = this;

    var params = {};
    var rowcount = {};

    var orderlist = {
      header: [
        { name: T('HP Order'                 ) },
        { name: T('Purchase Order Date'      ) },
        { name: T('Customer Purchase Order'  ) },
        { name: T('Order Type'               ) },
        { name: T('Customer Name'            ) },
        { name: T('Status'                   ) },
        { name: T('Shipment No'              ) },
        { name: T('Invoice No'               ) }
      ],
      data: orders.map( function(row) {
              if (1  ) {
                return [
                  <a onClick={self.handleClick.bind(null, row.legacy_order_no, row.k)} style={{ "cursor": "pointer" }}>{row.order_no}</a>,
                  fmDate(row.purch_order_date),
                  row.purchase_order_no,
                  row.order_type_descr,
                  row.customer_name,
                  row.order_overall_status,
                  row.shipment_no,
                  row.invoice_no
                ]
              } else {
                params.lookupValue = row.legacy_order_no;
                var onetimeKey = Onetime.OnetimeOrderKey ( row.legacy_order_no );
                var url = '?' + constructURL(params);
                return [
                  <a onClick={this.handleClick.bind(null,order.legacy_order_no)} style={{ "cursor": "pointer" }}>{row.order_no}</a>,
                  fmDate(row.purch_order_date),
                  row.purchase_order_no,
                  row.order_type_descr,
                  row.customer_name,
                  row.order_overall_status,
                  row.shipment_no,
                  row.invoice_no
                ]
              }
            })
    }

    return (
      <div>
        <div id="errorPane" style={{ display: "none", position: "relative" }}>
          <div id="errorPaneText" className="alert alert-danger errorPaneWidget"
               role="alert">
            error text
          </div>
        </div>
        <SimpleDataGrid header={orderlist.header} data={orderlist.data.sort()}/>
      </div>
      );
  }
};


//----------------------------------------------------------------------
//   ShowOrderWidgetPublic
//
//----------------------------------------------------------------------
window.ShowOrderWidgetPublic = function(legacy_order_no, k ) {

  var Params = {
      lookupType: "legacy_order_no",
      lookupValue: legacy_order_no,
      callingSystem: 'quickView',
      k: k,
      o: legacy_order_no
  }

  window.OnetimeWidget = {
      k: k,
      o: legacy_order_no
  } 

  $('#ossOrderModal').modal({
      backdrop: 'static'
  });

  GET("/os/ossui/v1/ex/widget/order", Params,
      function(resp) {
          //console.log(resp);

          if (resp.status == 'N') {
              alert(resp.message);
          } else {
              //console.log(resp.data);
              // now show everything
              $('#ossOrderModal').modal('hide');
              ReactDOM.render(
                <OSWidget
                  myWidgetMode='public'
                  quickSearchResp={null} order={resp.data} searchVal={null}/>
                , document.getElementById('externalWidget')
              );
              $('#ossOrderModal').modal({
                  backdrop: 'static'
              });
          }
      }
  );
}

//----------------------------------------------------------------------
//   PublicSelectModal
//
//----------------------------------------------------------------------
class PublicSelectModal extends React.Component {
  
  componentDidMount() {
      $('#ossOrderModal').modal('show');
  }

  render() {
    var order = this.props.data;
    var k     = this.props.k;
      $('#ossOrderModal').modal('show');

       return (
            <ModalWithClose id="ossOrderModal" handleClose={handleCloseModal} closeButtonText={T('Close')} width="995px">

              <ModalTitle handleClose={handleCloseModal}>
                <L>Multiple orders found</L>
                &nbsp;-&nbsp;
                <L>Please select</L>:
              </ModalTitle>

              <ModalBody>
                <PublicOrderSelectList orders={order} k={k}/>
              </ModalBody>

            </ModalWithClose>
        )
  }
};

//----------------------------------------------------------------------
//   OSWidgetSearch -- shows search mask
//
//----------------------------------------------------------------------
class OSWidgetSearch extends React.Component {

  constructor(props) {
    super(props);
  }

  handleWarningMsg(details) {
      $("#resultMsg").html(details.message);
      $("#resultMsg").addClass("alert alert-danger");
  }

  handleReset() {
      $("#resultMsg").html("");
      $("#resultMsg").removeClass("alert alert-danger");
  }

  validateSearchFields() {
      $("#resultMsg").html("");
      $("#resultMsg").removeClass("alert alert-danger");

      return true;
  }

  searchByHeader(searchParameters) {
    var params    = {};
    var searchQry = {};

    searchQry.searchBy = 'H'; // Header details search
    searchQry.id = searchParameters.id.trim();
    searchQry.id2 = searchParameters.id2.trim();
    searchQry.dateType = searchParameters.dateType;
    searchQry.dateTypeValue = searchParameters.dateTypeValue;
    searchQry.dateRange = searchParameters.dateRange;

    params.id = searchParameters.id.trim();
    params.id2 = searchParameters.id2.trim();
    params['g-recaptcha-response'] = searchParameters.captcha.trim();
    params.dateType = searchParameters.dateTypeValue;
    params.at = searchParameters.dateRange;
    params.mode = "exact";
    params.user = "publicWidgetUser";
    if ( searchParameters.dateRange != "") {
      var dates = searchParameters.dateRange.split(/\s+/);   // why use spaces?? and not " to "  ??
    //  params.at   = dates[0];
    }

    var self = this;

    POST("/os/ossui/v1/ex/custSearch",params, function(result) {
      //alert(JSON.stringify(result));
      //console.log(JSON.stringify(result));
      //console.log(result.data);
      //state.order = result;
      //state.searchQry = searchQry;
      $('#ossOrderModal').modal('hide');

      if (result.data.o) {
        console.log("result.data.o.length "+result.data.o.length);
        console.log("result.data.k "+result.data.k);
        if (result.data.k && result.data.k.length > 0) {
          ShowOrderWidgetPublic(result.data.o, result.data.k);
        } else if (result.data.o.length > 1) {
          console.log( 'Multiple orders matching filter criteria...' );

          POST("/os/ossui/v1/ex/public/order", result.data.o, function(resp) {
                  console.log("Data returned");
                  console.log("Response: " +(JSON.stringify(resp)));

            ReactDOM.render(
               <PublicSelectModal data={resp.data} k={resp.k}/>,
               document.getElementById('externalWidget')
            ); 

          });

        }
      } else {
        ReactDOM.render(
           <OSLandingPagePublic size={"large"} type={"default"} order={"order"}/>,
           document.getElementById('mainbody')
        );  
        if (result.message instanceof Array && result.message.length == 3) {
          var newMessage = T(result.message[0]) + result.message[1] + T(result.message[2]);
        } else {
          var newMessage = T(result.message);
        }
        $("#resultMsg").html(newMessage);
        $("#resultMsg").addClass("alert alert-danger");
      }
    });
  }

  searchByShipment(searchParameters) {
    var params    = {};
    var searchQry = {};

    searchQry.searchBy = 'S'; // Detail details search
    searchQry.id = searchParameters.id;
    searchQry.dateType = searchParameters.dateType;
    searchQry.dateTypeValue = searchParameters.dateTypeValue;
    searchQry.dateRange = searchParameters.dateRange;

    params.id = searchParameters.id.toUpperCase().replace(/^\s+|\s+$/g,'');
    params.dateType = searchParameters.dateTypeValue;
    params.at = "";
    if ( searchParameters.dateRange != "") {
      var dates = searchParameters.dateRange.split(/\s+/);   // why use spaces?? and not " to "  ??
      params.at   = dates[0];
    }

    POST("/os/ossui/v1/ex/prodSearch",params, function(result) {
      //alert(JSON.stringify(result));
      //console.log(JSON.stringify(result));
      //console.log(result.data);
      //state.order = result;
      //state.searchQry = searchQry;

      $('#ossOrderModal').modal('hide');

      if(result.data.rows.length > 1 ) {

        ReactDOM.render(
           <OSLandingPagePublic size={"large"} type={"searchresult"} order={result} searchQry={searchQry}/>,
           document.getElementById('mainbody')
        ); 

      } else if( result.data.rows.length == 1) {

        //console.log("result.data.rows[0].item_subitem[0]=====>"+result.data.rows[0].item_subitem[0]);
        // If the item data is returned then pass it over to ShowOrderWidget
        if ( typeof result.data.rows[0].item_subitem !== 'undefined' ) {
          ShowOrderWidgetPublic(result.data.rows[0].legacy_order_no,result.data.rows[0].item_subitem[0]);
        } else {
          ShowOrderWidgetPublic(result.data.rows[0].legacy_order_no);
        }
      } else {

          ReactDOM.render(
             <OSLandingPagePublic size={"large"} type={"default"} order={"order"}/>,
             document.getElementById('mainbody')
          ); 

        if (result.message instanceof Array && result.message.length == 3) {
          var newMessage = T(result.message[0]) + result.message[1] + T(result.message[2]);

        } else {

          var newMessage = T(result.message);

        }

        $("#resultMsg").html(newMessage);
        $("#resultMsg").addClass("alert alert-danger");
      }
    });
  }

  searchByInvoice(searchParameters) {
    var params    = {};
    var searchQry = {};

    searchQry.searchBy = 'I'; // Detail details search
    searchQry.id = searchParameters.id;
    searchQry.dateType = searchParameters.dateType;
    searchQry.dateTypeValue = searchParameters.dateTypeValue;
    searchQry.dateRange = searchParameters.dateRange;

    params.id = searchParameters.id.toUpperCase().replace(/^\s+|\s+$/g,'');
    params.dateType = searchParameters.dateTypeValue;
    params.at = "";
    if ( searchParameters.dateRange != "") {
      var dates = searchParameters.dateRange.split(/\s+/);   // why use spaces?? and not " to "  ??
      params.at   = dates[0];
    }

    POST("/os/ossui/v1/ex/prodSearch",params, function(result) {
      //alert(JSON.stringify(result));
      //console.log(JSON.stringify(result));
      //console.log(result.data);
      //state.order = result;
      //state.searchQry = searchQry;

      $('#ossOrderModal').modal('hide');

      if(result.data.rows.length > 1 ) {

        ReactDOM.render(
           <OSLandingPagePublic size={"large"} type={"searchresult"} order={result} searchQry={searchQry} />,
           document.getElementById('mainbody')
        );

      } else if( result.data.rows.length == 1) {

        //console.log("result.data.rows[0].item_subitem[0]=====>"+result.data.rows[0].item_subitem[0]);
        // If the item data is returned then pass it over to ShowOrderWidgetPublic
        if ( typeof result.data.rows[0].item_subitem !== 'undefined' ) {
          ShowOrderWidgetPublic(result.data.rows[0].legacy_order_no,result.data.rows[0].item_subitem[0]);
        } else {
          ShowOrderWidgetPublic(result.data.rows[0].legacy_order_no);
        }
      } else {

            ReactDOM.render(
               <OSLandingPagePublic size={"large"} type={"default"} order={"order"}/>,
               document.getElementById('mainbody')
            );

        if (result.message instanceof Array && result.message.length == 3) {
          var newMessage = T(result.message[0]) + result.message[1] + T(result.message[2]);

        } else {

          var newMessage = T(result.message);

        }

        $("#resultMsg").html(newMessage);
        $("#resultMsg").addClass("alert alert-danger");
      }
    });
  }

  closeErrorPane() {
    $("#errorPane").hide();
  }

  render() {

    var self = this;

    var searchQry = this.props.searchQry;
    var searchQry2 = this.props.searchQry;

    // Blanking out strings if any
    if ( typeof searchQry != 'object' ) {
      searchQry = {};
    }

    // Default search qry to header tab if not exists.
    searchQry = searchQry||{searchBy:'H'};

    if (this.props.showOrder) {
        searchQry.id = this.props.showOrder;
    }

    //IF search by is blank then set to H
    if ( ! searchQry.searchBy ||
          (searchQry.searchBy != 'H' &&
           searchQry.searchBy != 'I' &&
           searchQry.searchBy != 'D') )  {
      searchQry.searchBy = 'H'
    }
    var searchQryHeader={};
    var searchQryHeader2={};
    var searchQryShipment={};
    var searchQryInvoice={};

    // Default search qry to header tab if not exists.

    // Copy over fields
    if (searchQry && searchQry.searchBy && searchQry.searchBy == 'H') {
      searchQryHeader = $.extend({},searchQry);
      searchQryHeader2 = $.extend({},searchQry2);
    } else if (searchQry && searchQry.searchBy && searchQry.searchBy == 'S') {
      searchQryShipment = $.extend({},searchQry);
    } else if (searchQry && searchQry.searchBy && searchQry.searchBy == 'I') {
      searchQryInvoice = $.extend({},searchQry);
    }

    // Define a DateTypeMap
    var dateTypeMap = {'no_select':T('Select Date Type'),
                   'purchaseOrderDate':T('Order Date'),
                   'shippedDate':T('Shipment Date'),
                   'invoiceDate':T('Invoice Date')};
    var dateTypeMapS = {'':T('Select Date Type'),
                   'shippedDate':T('Shipment Date')};
    var dateTypeMapI = {'':T('Select Date Type'),
                   'invoiceDate':T('Invoice Date')};

    return (
     <div className="_container-fluid _col-md-12 _margintop10">
      <h3>
        <span style={{fontWeight: "500", color: "#777"}}>
          Order Status
        </span>
        <span style={{float: "right", fontSize: "medium", fontWeight: "500", padding: "10px"}}>
          <img src="/static/dist/images/questionIcon.jpg"></img>
          &nbsp;
          <a target="_blank" href="/os/pub/assets/HP_OrderStatus_PublicViewer.pdf">Learn more about Order Status</a>
        </span>
      </h3>
      <div>
          <div id="errorPane" style={{ display: "none", position: "relative" }} onClick={this.closeErrorPane}>
            <div id="errorPaneText" className="alert alert-danger errorPaneWidget"
                 role="alert">
              error text
            </div>
          </div>
      </div>

      <div id="osWidgetSearchCriteria">

           <OSWidgetSearchTab tabData={{
                                      tabIndicator:'H', // H = Header, D = Details
                                      blockTitle:  T('Search your orders by filling in one basic search value, one additional value and a date'),
                                      searchHint:  T("Customer PO / HP Order / Web Order / Shipping ID"),
                                      searchQry:   searchQryHeader,
                                      searchHint2: T("Invoice No / Zip Code / Contract No / Email / Ship To Company (first line) / Deal ID"),
                                      searchQry2:  searchQryHeader2,
                                      dateTypeMap: dateTypeMap,
                                      showOrder:   self.props.showOrder
                                      
                                    }}
                              handleReset={self.handleReset}
                              validateSearchFields={self.validateSearchFields}
                              handleWarningMsg={self.handleWarningMsg}
                              handleSearch={self.searchByHeader} />

      </div>
      <div style={{"position":"relative"}}>
      </div>
      <div style={{"width":"22px", "height":"18px"}}></div>
    </div>
    )   
  }
};

//----------------------------------------------------------------------
//   OSWidgetSearchTab -- Tab for search criteria
//   TO DO : Based on inputs from team
//       CSS can also be localized to component than direct access
//       Validation message directly access DOM should it change?
//          Temporarily moved it to parent
//----------------------------------------------------------------------
class OSWidgetSearchTab extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      tabIndicator : this.props.tabData.tabIndicator,
      captcha : '',
      searchValue : this.props.tabData.searchQry.id || '',
      searchValue2 : this.props.tabData.searchQry.id2 || '',
      dateTypeValue : this.props.tabData.searchQry.dateTypeValue || '',
      dateRangeValue : this.props.tabData.searchQry.dateRange || '',
      captchaWarn : false,
      dateRangeWarn : false,
      dateTypeWarn : false
    };
    this.onChange = this.onChange.bind(this);
    this.onCaptchaVerification = this.onCaptchaVerification.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.validateSearchFields = this.validateSearchFields.bind(this);
    this.updateDateRange = this.updateDateRange.bind(this);
    this.updateDateType = this.updateDateType.bind(this);
  }

  onCaptchaVerification(value) {
    this.setState({captcha: value});
  }
  
  onChange(e) {
    switch ( e.target.id ) {
      case 'compSearchId'  : this.setState({searchValue:  e.target.value}); break;
      case 'compSearchId2' : this.setState({searchValue2: e.target.value}); break;
    }
  }

  handleKeyDown(e){
    if (e.keyCode == 13) {
      this.handleSearch();
    }
  }

  handleSearch() {
    // Validate the input
    var isValid = this.validateSearchFields();
    // if valid proceed to execute the search
    if ( isValid ) {
      var dateTypeSelectedText = this.props.tabData.dateTypeMap[this.state.dateTypeValue];
      this.props.handleSearch(
                    {
                      id : this.state.searchValue,
                      id2 : this.state.searchValue2,
                      captcha : this.state.captcha,
                      dateType : dateTypeSelectedText,
                      dateTypeValue : this.state.dateTypeValue,
                      dateRange : this.state.dateRangeValue
                    });
      window.grecaptcha.reset();
    }
  }

  handleReset() {
    this.props.handleReset(); // Delegate to Parent
    $("#dateRangeValue").val('');
    $("#dateTypeValue").val('no_select');
    this.setState({ 
      searchValue: '',
      searchValue2 : '',
      captcha : '',
      dateType: '',
      dateTypeValue : 'no_select',
      selectedValue : 'no_select',
      dateRangeValue : '',
      dateRangeWarn : false,
      dateTypeWarn : false,
      captchaWarn : false
    });    
    window.grecaptcha.reset();
  }

  validateSearchFields () {
    var isValid = true;
    // Delegate to Parent
    isValid = this.props.validateSearchFields();

    if ( this.state.searchValue == "" ||
         this.state.searchValue2 == "" ) {
      isValid = false;
      //this.props.handleWarningMsg({message:T('warn_no_criteria')});
      this.props.handleWarningMsg({message:T('Please enter all search criteria')});
    } else if (this.state.dateTypeValue == "" || this.state.dateTypeValue == "no_select") {
      isValid = false;
      this.setState({dateTypeWarn: true});
      this.props.handleWarningMsg({message:T('warn_date_type')});
    } else if ( this.state.dateTypeValue != "" && this.state.dateRangeValue == "" ) {
      isValid = false;
      this.setState({dateRangeWarn: true});
      //this.props.handleWarningMsg({message:T('warn_date')});
      this.props.handleWarningMsg({message:T('Please enter a valid date')});
    } else if (    (this.state.captcha == "") ) {
      isValid = false;
      this.setState({captchaWarn: true});
      this.props.handleWarningMsg({message:T('You have to enter the captcha text')});
    }

    return isValid;
  }

  updateDateRange(val) {
    this.setState({dateRangeValue: val});
  }

  updateDateType (val) {
    this.setState({dateTypeValue: val});
  }

  render() {

    var helpText = "You have to enter all search criteria in order to find a particular order"

    var dateTypeDropDown = [];
    //dateTypeDropDown.push(<option value=''><L>Select Date Type</L></option>);

    for (var key in this.props.tabData.dateTypeMap ) {
      if ( this.props.tabData.dateTypeMap.hasOwnProperty(key) )  {
        dateTypeDropDown.push(<option value={key}>{this.props.tabData.dateTypeMap[key]}</option>);
      }
    }

    var ranges = {};
    ranges[T('Yesterday')]     = [moment().subtract(1,'days'),                   moment().subtract(1,'days')];
    ranges[T('Last Week')]     = [moment().subtract(1,'week').startOf('week'),   moment().subtract(1,'week').endOf('week')];
    ranges[T('Current Week')]  = [moment().startOf('week'),                      moment().endOf('week')];
    ranges[T('Last Month')]    = [moment().subtract(1,'month').startOf('month'), moment().subtract(1,'month').endOf('month')]
    ranges[T('Last 3 Months')] = [moment().subtract(3,'month').startOf('month'), moment().subtract(1,'month').endOf('month')]
    ranges[T('Current Year')]  = [moment().startOf('year'),                      moment().endOf('year')];

    return (
    <div>
      <div className="blockTitle">
         {this.props.tabData.blockTitle}:
       </div>
      <div className="blockBody">
        <table className="formTableExt">
         <tr>
           <td width="12%"><L>searchID</L>:</td>
           <td colSpan="3" width="80%">
             <input type="text" className="form-control" id="compSearchId"
                    autocomplete="off"
                    value={this.state.searchValue}
                    onChange={this.onChange}
                    placeholder={this.props.tabData.searchHint}
                    onKeyDown={this.handleKeyDown} />
           </td>
         </tr>

         <tr>
           <td width="12%"><L>Additional Value</L>:</td>
           <td colSpan="3" width="80%">
             <input type="text" className="form-control" id="compSearchId2"
                    value={this.state.searchValue2}
                    autocomplete="off"
                    onChange={this.onChange}
                    placeholder={this.props.tabData.searchHint2}
                    onKeyDown={this.handleKeyDown} />
           </td>
         </tr>

         <tr>
           <td width="12%"><L>Date</L>:</td>
           <td width="30%">
             <OSSelectionCmp id="dateTypeValue" warn={this.state.dateTypeWarn}
                             onChange={this.updateDateType}
                             selectionOptions={this.props.tabData.dateTypeMap}
                             selectedValue={this.state.dateTypeValue}
                             ref="dateSelection" />
           </td>
           <td colSpan="2" width="50%">
             <DateChooser id="dateRangeValue" dateValue={this.state.dateRangeValue} placeholder={T('YYYY-MM-DD')} 
                          onChange={this.updateDateRange}
                          style={{display:"inline", width:"14ex", fontSize:"13px", padding:"4px", marginBottom: "-15px" }}/>
           </td>
         </tr>
         <tr>
           <td>&nbsp;</td>
           <td colSpan="2" >

            <ReactRecaptcha
              sitekey="6LcwWV4UAAAAAIMLTRPXZUWyHUuzggn8yr9MGdvk"
              render="explicit"
              onloadCallback={() => console.log('ReactRecaptcha rendered')}
              verifyCallback={this.onCaptchaVerification}
            />

           </td>
         </tr>
         <tr>
          <td>&nbsp;</td>
          <td>
           <button id="orderSearchButton" className="btn btn-inline btn-primary btn-sm leftMargin10" onClick={this.handleSearch}><L>Search</L></button>
           &nbsp;
           <button className="btn btn-inline btn-primary btn-sm leftMargin10" onClick={this.handleReset}><L>Reset</L></button>
          </td>
          <td>
           <div style={{"margin": "0px"}} className="timelineMiddleInfo"><a className="tooltips"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><div className="classic">{helpText}</div></a></div>
          </td>
         </tr>
        </table>
      </div>
    </div>
    );

  }
};


//----------------------------------------------------------------------
//   OSCalendarRangeCmp -- Custom Calendar Component
//   Properties
//                   warn : True if background needs change color
//               onChange : function that needs to be involed on change value
//                 ranges : Range Options to be used JS Array
//                          ranges[T('Yesterday')]     = [moment().subtract(1,'days'), moment().subtract(1,'days')];
//                          ranges[T('Last Week')]     = [moment().subtract(1,'week').startOf('week'), moment().subtract(1,'week').endOf('week')];
//         dateRangeValue : Default or selected date range
//            placeholder : Place holder text
//----------------------------------------------------------------------
class OSCalendarRangeCmp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dateRangeValue: this.props.dateRangeValue
    };
    this.onChange         = this.onChange.bind(this);
    this.handleKeyDown    = this.handleKeyDown.bind(this);
    this.attachDatePicker = this.attachDatePicker.bind(this);
  }

  onChange(val) {
    // This is direct event so get the text value
    if ( val.target ) {
      val = val.target.value;
    }
    this.setState({dateRangeValue: val});
    if ( this.props.onChange ) {
      this.props.onChange(val);
    }
  }

  handleKeyDown(e){
      if ( this.props.handleKeyDown) {
          this.props.handleKeyDown(e);
      }
  }

  attachDatePicker() {
    var self = this;
    var ranges = this.props.ranges;

    var dateRangeCmp  = ReactDOM.findDOMNode(this.refs["dateRange"]); 
    $(dateRangeCmp).daterangepicker({
      singleDatePicker: true,
      opens: 'left',
      startDate: new Date(),
      format: 'YYYY-MM-DD'
    }, function(start, end, label) {
      // Indivudial fields can be stored in state and used too!!
      self.onChange(start.format('YYYY-MM-DD') );
    });
  }

  componentDidMount() {
    this.attachDatePicker();
  }

  render() {
    var defaultClassName="form-control";
    if ( this.props.warn ) {
      defaultClassName="form-control warnTextbox";
    }

    return (
      <input type="text"
             className={defaultClassName}
             value={this.state.dateRangeValue}
             onChange={this.onChange}
             placeholder={this.props.placeholder}
             ref="dateRange"
             onKeyDown={this.handleKeyDown}  />
    );
  }
};

//----------------------------------------------------------------------
//   OSSelectionCmp -- Custom DropDown Component
//   Properties
//                   warn : True if background needs change color
//               onChange : function that needs to be involed on change value
//       selectionOptions : Options as JS Object {'': 'Please Select', K1':'This is K1', 'K2' : 'This is K2'}
//          selectedValue : default selected value
//----------------------------------------------------------------------
class OSSelectionCmp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedValue: this.props.selectedValue,
    };
    this.onChange       = this.onChange.bind(this);
    this.handleKeyDown  = this.handleKeyDown.bind(this);
  }

  onChange(e) {
    this.setState({selectedValue: e.target.value});
    if ( this.props.onChange ) {
      this.props.onChange(e.target.value);
    }
  }

  handleKeyDown(e){
      // Delegate to parent
      if ( this.props.handleKeyDown ) {
          this.props.handleKeyDown(e);
      }
  }

  render() {
    var defaultClassName="form-control";
    if ( this.props.warn ) {
        defaultClassName="form-control warnTextbox";
    }
    var selectionOptions = [];

    for (var key in this.props.selectionOptions ) {
      if ( this.props.selectionOptions.hasOwnProperty(key) )  {
        selectionOptions.push(<option value={key}>{this.props.selectionOptions[key]}</option>);
      }
    }

    return (
         <select id={this.props.id}
                 className={defaultClassName}
                 onChange={this.onChange}
                 value={this.props.selectedValue}
                 ref="dateSelection"
                 onKeyDown={this.handleKeyDown} >
           {selectionOptions}
         </select>
    );
  }
};

//----------------------------------------------------------------------
//   OSLandingPagePublic -- show dashboard or search mask
//
//----------------------------------------------------------------------
export class OSLandingPagePublic extends React.Component {

  constructor(props) {
    super(props);
    this.handleBack = this.handleBack.bind(this);
  }

  handleBack() {
    var searchQry = this.props.searchQry;
    $("#mainbody").empty(); // hack
    ReactDOM.render(
       <OSLandingPagePublic size={"large"} type={"default"} order={null} searchQry={searchQry} />,
       document.getElementById('mainbody')
    ); 
  }

  render() {

      var width = "995px";
      if (this.props.width) {
        width = this.props.width;
      }

      console.log("OSLandingPagePublic this.props.type======++++==>");
      console.log(this.props.type);
      console.log(this.props.showOrder);
      var showOrder = "";
      if (this.props.showOrder) {
          showOrder = this.props.showOrder;
      }

      var searchQry = this.props.searchQry;

      if (this.props.type == "default") {
          if (showOrder != "") {
              setTimeout( function() {
                   $("#orderSearchButton").click();    
              }, 900);
          }
          return (
            <div id='defaultLandingPage'>
              <div id="resultMsg"></div>
              <OSWidgetSearch searchQry={searchQry}  showOrder={showOrder} />
            </div>
          )
      } else {

          var order = this.props.order.data.rows;
          var columns = this.props.order.data.columns;
          var length = this.props.order.data.rows.length;

          var dataRangeStr = null;

          if (this.props.searchQry.dateRange != "") {
              dataRangeStr = this.props.searchQry.dateType + " ( " + this.props.searchQry.dateRange + " )";
          }

          var searchVal = this.props.searchQry.id;
          var searchVal2 = this.props.searchQry.id2;
          setTimeout( function() {
            $("#orderSelectList td").highlight(searchVal,'highlighted');
            $("#orderSelectList td a").highlight(searchVal,'highlighted');
          }, 100);

          var type = this.props.type;
          console.log('this.props.searchQry.bucket:'+this.props.searchQry.bucket);
          var bucket = this.props.searchQry.bucket;
          var OrdersList = order.map(function(order,i){
              return <SearchResult data={order} type={type} bucket={bucket}/>
          });
          var displayTable = (
              <table className="table" id="orderSelectList">
                <thead>
                  <tr>
                    <th><L>HP Order</L></th>
                    <th><L>Purchase Order No</L></th>
                    <th><L>Purchase Order Date</L></th>
                    <th><L>Quote No</L></th>
                    <th><L>Summarized Status</L></th>
                    <th><L>ship_to_addr_1</L></th>
                    <th><L>ship_to_attn</L></th>
                    <th><L>Customer Notes</L></th>
                  </tr>
                  </thead>
                    <tbody>
                      {OrdersList}
                    </tbody>
              </table>
          )


          var type   = "preDefTemplate";
          var header = "";
          var exportURL = "";
          if (this.props.searchQry.bucket == "All Bucket" && this.props.searchQry.range == "ALL") {
              exportURL = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExport/submittedOrders/total/1/"+I18N.locale);
          } else {
              exportURL = RewriteRESTURL("/os/ossui/v1/ex/externalDrilldownForExport/"+this.props.searchQry.bucket+"/"+this.props.searchQry.range+"/0/"+I18N.locale);
          }

          var exportToExcel    = "";
          var multipleOrderMsg = "";

          if (this.props.type == "dashboard") {
            if (length <= exportExcelMaxLimit) {
                  exportToExcel = (
                      <div style={{"background": "#0096d6","minWidth": "30px","padding": "4px 4px 5px 6px","textAlign": "left"}}>
                        <a href={exportURL} style={{"color":"#fff"}}>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down"/>&nbsp;</a>
                      </div>
                  )
              } else {
                  exportToExcel = (
                      <div title="Export Limit of {exportExcelMaxLimit} orders reached" style={{"background": "#0096d6","minWidth": "30px","padding": "4px 4px 5px 6px","textAlign": "left"}}>
                        <a disabled style={{"color":"#767676"}}>&nbsp;<i className="glyphicon glyphicon-circle-arrow-down"/>&nbsp;</a>
                      </div>
                  )
              }
          }

          if (this.props.type != "dashboard") {
            multipleOrderMsg = (
              <div className="col-md-12 bottompadding5" >
                  <div id="drillDownHeader" style={{"background": "#f5f5f5","minWidth": "30px","padding": "3px 3px 3px 6px","textAlign": "left", "border": "1px solid #ccc"}}>
                      <div className="btn-group">
                          <L>Multiple orders found - Please select:</L>
                      </div>
                  </div>
              </div>
            )
          }

          if (this.props.type == "dashboard") {

            var bucketText = this.props.searchQry.bucket;
            var rangeText  = this.props.searchQry.range;

            header = (
              <table className="wideTableExt">
                <tr>
                  <td>
                    <button type="button" className="btn btn-primary btn-sm" onClick={this.handleBack}><L>Back</L></button>
                  </td>
                  <td>
                    <label className="control-label"><L>{bucketText}</L>&nbsp;<L>order_bucket</L></label>
                  </td>
                  <td>
                    <label className="control-label"><L>Ordering Period</L>:</label>&nbsp;<L>{rangeText}</L>
                  </td>
                </tr>
              </table>
            )

          } else {
            var searchIDText = "";
            var searchDateText = "";

            if (this.props.searchQry.id && this.props.searchQry.id != "") {
              searchIDText = (
                <div>
                  <label className="control-label"><L>searchID</L>:&nbsp;</label>
                 {this.props.searchQry.id}
                </div>
              )
            }
            if (dataRangeStr && dataRangeStr != "" && this.props.searchQry.id && this.props.searchQry.id != "") {
              searchDateText = (
                <div>
                  <label className="control-label"><L>and</L>&nbsp;</label>
                  {dataRangeStr}
                </div>
              )
            } else if (dataRangeStr && dataRangeStr != "") {
              searchDateText = (
                <div>
                  <label className="control-label"><L>searchID</L>:&nbsp;</label>
                  {dataRangeStr}
                </div>
              )
            }

            header = (
              <table className="wideTableExt">
                <tr>
                  <td>
                    <button type="button" className="btn btn-primary btn-sm" onClick={this.handleBack}><L>Back</L></button>
                  </td>
                  <td>
                    {searchIDText}
                  </td>
                  <td>
                    {searchDateText}
                  </td>
                </tr>
              </table>
            )
          }

          return (
            <div id='multipleOrdersLandingPage' style={{'width': '860px'}}>
                 <div>
                      {header}
                      {exportToExcel}
                  </div>
                  {displayTable}
                  <button type="button" className="btn btn-primary btn-sm" onClick={this.handleBack}><L>Back</L></button>
            </div>
          )
      }
  }
};


function ShpTypeIcon ( shipping_type )
{
   if (shipping_type.toLowerCase() == "train"   ) return <img src={train_icon}/>;
   if (shipping_type.toLowerCase() == "rail"    ) return <img src={train_icon}/>;
   if (shipping_type.toLowerCase() == "airplane") return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "air")      return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "vessel"  ) return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "sea"     ) return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "ocean"   ) return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "ship/air") return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "a0"      ) return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "a1"      ) return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "m"       ) return <img src={Shipping_RGB_blue_NT}/>;
   // M->Truck mapping after discussion with Titus and Oliver, this is for seen for VISTA orders
   return  <img height="16" src={Shipping_RGB_blue_NT} />
}

